import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page40() {
  useEffect(() => {
    document.title = "Маяк — Страница 39"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page38" />
        <ForwardLink href="/page40" />
      </div>

      <p style={{ textAlign: "right" }}>39.</p>
      <p>
        Он видит СТАРИКА, рыдающего в подушку и одеяла. <i>Он спит,<br/>
        -- не так ли?</i> Это очень уязвляющее зрелище.
      </p>
      <p>МОЛОДОЙ не знает, что делать.</p>
      <p>Задержка.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – ДЕНЬ</p>
      <p>
        Лицо МОЛОДОГО отражается в блестящей медной детали.<br/>
        На его выражение лица все еще влияют две предыдущие сцены. Он<br/>
        плюет на медь и продолжает полировать.
      </p>
      <p>СТАРИК наблюдает за работой МОЛОДОГО, записывая в свой журнал.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ветер сменился.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Скатертью дорожка.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не будь таким глупым. Это<br/>
        затишье перед бурей, Уинслоу.<br/>
        Был тихий западный ветер, который ты<br/>
        проклинал. Ощущение только грубое, потому что<br/>
        ты ни о чем не знаешь,<br/>
        и на этой скале нет таких деревьев, как твой буш<br/>
        в Гудзоновом заливе. И восточный ветер скоро<br/>
        завоет как рог Габриэля.<br/>
        Лучше всего заколотить окна на сигнальной<br/>
        станции.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Думаю, продержимся до того, как тендер<br/>
        придет утром… но<br/>
        надвигается ненастная погода.
      </p>
      <p>МОЛОДОЙ не смотрит СТАРИКУ в глаза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Таишь обиду?
      </p>
      <p style={{ textAlign: "center" }}>
        Ты покинешь этот остров завтра,<br/>
        Уинслоу, не злись на меня<br/>
        сейчас.
      </p>
      <p style={{ textAlign: "right" }}>39.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page38" />
        <ForwardLink href="/page40" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710021583/the-lighthouse-script/xywwuegs0kgrsyj65pmf.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page40;
